import * as actionTypes from './actionTypes';

export const setFilterValue= (value)=>{
    
    return {
      
      type: actionTypes.SET_FILTER_VALUE,
        value:value
    
  }; 
}

export const setFilterKey= (what)=>{
    
    return {
      
      type: actionTypes.SET_FILTER_KEY,
        what:what
  }; 
}

export const setData= (data)=>{
    
    return {
      
      type: actionTypes.SET_DATA,
        data:data
  }; 
}



// WEBPACK FOOTER //
// ./src/store/actions/search.js